<template>
  <div class="zj-moble-app-page">
    <mt-header class="zj-mt-header" fixed="true" title="交易记录">
      <router-link to="/m/payment/orderList" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
       <mt-button slot="right"  @click="popupVisible = true">查询</mt-button>
    </mt-header>
    <div class="zj-mt-content">
      <div class="orderspace" >
        <div class="orderSum"><span class="sumTitle">登录商户名称：</span><div class="sumValue"><span>{{LoginBusinessName}}</span></div></div>
        <div class="orderSum"><span class="sumTitle">交易总金额：</span><div class="sumValue"><span>{{SumTrxAmount}}</span></div></div>
        <div class="orderSum"><span class="sumTitle">获得分账金额：</span><div class="sumValue"><span>{{GetPaySeparate}}</span></div></div>
        <div class="orderSum"><span class="sumTitle">查询时间：</span><div class="sumValue"><span>{{Time_Start}}</span></div></div>
        <div class="orderSum"><span class="sumTitle"></span><div class="sumValue"><span>至</span></div></div>
        <div class="orderSum"><span class="sumTitle"></span><div class="sumValue"><span>{{Time_End}}</span></div></div>
      </div>
      <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="5" infinite-scroll-immediate-check="false">
        <li class="orderspace" :key="orderitem.DetialId" v-for="orderitem in orderdatas">
          <div class="order_item_num">
            <div class="item_l_num">订单号</div>
          </div>
          <div class="order_item_num">
            <div class="item_v_num">{{orderitem.OrderNo}}</div>
          </div>
           <div class="order_item_num">
            <div class="item_l_num">子订单号</div>
          </div>
          <div class="order_item_num">
            <div class="item_v_num">{{orderitem.ChildOrderNo}}</div>
          </div>
          <div class="order_item">
            <div class="item_l">订单金额</div>
            <div class="item_v">{{orderitem.PaySign}}{{orderitem.TrxAmount}}元</div>
          </div>
          <div class="order_item">
            <div class="item_l">主账户分账金额</div>
            <div class="item_v">{{orderitem.PaySign}}{{orderitem.MainPaySeparate}}元</div>
          </div>
          <div class="order_item">
            <div class="item_l">二级商户分账金额</div>
            <div class="item_v">{{orderitem.PaySign}}{{orderitem.PaySeparate}}元</div>
          </div>
          <div class="order_item">
            <div class="item_l">交易状态</div>
            <div v-if="orderitem.Status==1" class="item_v">支付成功</div>
            <div v-if="orderitem.Status==2" class="item_v">退款成功</div>
            <div v-if="orderitem.Status==3" class="item_v">退款失败</div>
            <div v-if="orderitem.Status==4" class="item_v">待支付</div>
            <div v-if="orderitem.Status==5" class="item_v">订单取消</div>
            <div v-if="orderitem.Status==6" class="item_v">提现中</div>
            <div v-if="orderitem.Status==7" class="item_v">提现成功</div>
            <div v-if="orderitem.Status==8" class="item_v">提现失败</div>
          </div>
          <div class="order_item">
            <div class="item_l">支付时间</div>
            <div class="item_v_time">{{orderitem.CreateTime.replace("T"," ")}}</div>
          </div>
        </li>
         <li class="more_loading" v-show="!queryLoading">
          <mt-spinner type="snake" color="#00ccff" :size="50" v-show="moreLoading&&!allLoaded"></mt-spinner>
          <span v-show="allLoaded">已全部加载</span>
        </li>
      </ul>
    </div>
    <div class="search">
         <mt-popup v-model="popupVisible" position="right" modal="false">
            <div class="popupItem" @click="selectBusiness"><span class="popupName">商户：</span><div class="popupValue"><span>{{BusinessName}}</span></div></div>
            <div class="popupItem" @click="selectChildBusiness"><span class="popupName">子商户：</span><div class="popupValue"><span>{{ChildBusinessName}}</span></div></div>
            <div class="popupItem" @click="selectPayStatus"><span class="popupName">交易状态：</span><div class="popupValue"><span>{{PayStatusName}}</span></div></div>
            <div class="popupItem"><span class="popupName">订单号：</span><div class="popupValue"><mt-field label="" placeholder="请输入订单号" v-model="Order_Code"></mt-field></div></div>
            <div class="popupItem" @click="selectStartTime"><span class="popupName">开始时间：</span><div class="popupValue"><span>{{Time_Start}}</span></div></div>
            <div class="popupItem" @click="selectEndTime"><span class="popupName">截止时间：</span><div class="popupValue"><span>{{Time_End}}</span></div></div>
            <div class="searchbutton">
              <mt-button type="default" @click="SearchOrders">查询</mt-button>
              <mt-button type="default"  @click="popupVisible = false">取消</mt-button>
            </div>
        </mt-popup>
    </div>
    <div class="select">
        <mt-popup v-model="BusinessVisible" position="bottom" modal="false">
           <mt-picker :slots="slots" :itemHeight="80" valueKey="BusinessName" @change="onValuesChange"></mt-picker>
        </mt-popup>
        <mt-popup v-model="ChildBusinessVisible" position="bottom" modal="false">
            <mt-picker :slots="childslots" :itemHeight="80" valueKey="ChildBusinessName" @change="onChildValuesChange"></mt-picker>
        </mt-popup>
        <mt-popup v-model="PayStatusVisible" position="bottom" modal="false">
            <mt-picker :slots="PayStatusesslots" :itemHeight="80" valueKey="PayStatusName" @change="onPayStatusValuesChange"></mt-picker>
        </mt-popup>
    </div>
    <div class="selecttime">
      <mt-datetime-picker position="bottom"
          v-model="Time_StartTime"
          ref="TimeStartPicker"
          type="date"
          @confirm="handleStartTimeConfirm">
        </mt-datetime-picker>
         <mt-datetime-picker position="bottom"
          v-model="Time_EndTime"
          ref="TimeEndPicker"
          type="date"
          @confirm="handleEndTimeConfirm">
        </mt-datetime-picker>
    </div>
  </div>
 
</template>

<script>

import Vue from 'vue'
import { Cell } from 'mint-ui';
Vue.component(Cell.name, Cell);
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import { Popup } from 'mint-ui';
Vue.component(Popup.name, Popup);
import { Picker } from 'mint-ui';
Vue.component(Picker.name, Picker);
import { DatetimePicker } from 'mint-ui';
Vue.component(DatetimePicker.name, DatetimePicker);
import moment from 'moment';

import { InfiniteScroll } from 'mint-ui';
Vue.use(InfiniteScroll);
import { Spinner } from 'mint-ui';
Vue.component(Spinner.name, Spinner);

import WebApis from "../../apis";
import utils from '../../../../../../utils';

export default {
  name: "outPayList",
  controller: "UI",
  action: "outPayList",
  data() {
      return {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        tableData: [],
        orderdatas:[],
        Order_Code: null,
        SelectedOrderNo: null,
        Businesses:[],
        BusinessStrs:[],
        BusinessCode:"",
        BusinessName:"",
        BusinessCodeDisabled:false,
        ChildBusinesses:[],
        ChildBusinessCode:"",
        ChildBusinessName:"",
        ChildBusinessCodeDisabled:false,
        PayStatus:0,
        PayStatusName:"请选择交易状态",
        user:"",
        ThisBusiness:"",
        popupVisible:false,
        BusinessVisible:false,
        ChildBusinessVisible:false,
        PayStatusVisible:false,
        Time_Start: "",
        Time_StartTime:new Date(),
        Time_End: "",
        Time_EndTime:new Date(),
        TimeStartPickerVisible:false,
        TimeEndPickerVisible:false,
        slots:[
          {
            flex:1,
            values:this.BusinessItems,
            defaultIndex:1000,
            className:"slot1",
            textAlign:"center"
          }
        ],
        childslots:[
          {
            flex:1,
            values:this.ChildBusinessItems,
            defaultIndex:1000,
            className:"slot1",
            textAlign:"center"
          }
        ],
        PayStatusesslots:[
          {
            flex:1,
            values:this.PayStatuses,
            defaultIndex:1000,
            className:"slot1",
            textAlign:"center"
          }
        ],
        BusinessItems:[
          {
            "BusinessName":"请选择商户",
            "BusinessCode":null
          }
        ],
        ChildBusinessItems:[
          {
            "BusinessName":"请选择子商户",
            "BusinessCode":null
          }
        ],
        PayStatuses:[
        {
          PayStatusId:0,
          PayStatusName:"全部"
       },
       {
          PayStatusId:1,
          PayStatusName:"支付成功"
       },
        {
          PayStatusId:2,
          PayStatusName:"已退款"
       },
        {
          PayStatusId:7,
          PayStatusName:"提现成功"
       }
      ],
        queryLoading: false,
        moreLoading:false,
        allLoaded:false,
        InSumData:{
          SumTrxAmount:0,
          SumPaySeparate:0,
          SumMainPaySeparater:0
        },
        ReturnSumData:{
          SumTrxAmount:0,
          SumPaySeparate:0,
          SumMainPaySeparater:0
        },
        SumTrxAmount:0,
        SumPaySeparate:0,
        SumMainPaySeparater:0,
        GetPaySeparate:0,
        LoginBusinessCode:"",
        LoginBusinessName:"",
        LoginIsMain:""
        
      }
  },
  created() {

     var _this = this;

     _this.currentPage=1;
     _this.pageSize=10;
     _this.total=0;
    var loginuserjson = localStorage.getItem('loginuser');

    this.user = JSON.parse(loginuserjson);

    if(this.user.LoginName!="admin")
    {
      this.ThisBusiness = this.GetBusinessByUser(this.user);
      this.BusinessCode=this.ThisBusiness.BusinessCode;
    }

    this.PayStatusesslots[0].values=this.PayStatuses;

    this.Time_Start=this.get_Day(0)+" 00:00:00",
    this.Time_End=this.get_Day(0)+" 23:59:59",

    this.Time_StartTime=new Date(this.Time_Start);
    this.Time_EndTime=new Date(this.Time_End);
    this.init();
  },
  methods: {
    init() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      return utils.waitAll([
                            () => this.GetBusiness()
                          ]).then(()=>{
                            this.InitLogin();
                            this.initSum();
                            this.GetOutPayment();
                          });
    },
    initSum()
    {
        return utils.waitAll([
                            () => this.InGetSum(),
                            () => this.ReturnGetSum()
                          ]).then(()=>{
                            this.GetSumData();
                          });
    },
    onValuesChange(picker, values) {
      if(values[0])
      {
        this.BusinessName=values[0].BusinessName;
        this.BusinessCode=values[0].BusinessCode;
        this.GetChildBusinesses(this.BusinessCode);
      }
    },
    onChildValuesChange(picker, values) {
      if(values[0])
      {
        this.ChildBusinessName=values[0].ChildBusinessName;
        this.ChildBusinessCode=values[0].ChildBusinessCode;
      }
    },
    onPayStatusValuesChange(picker, values) {
      if(values[0])
      {
        this.PayStatusName=values[0].PayStatusName;
        this.PayStatus=values[0].PayStatusId;
      }
    },
    GetBusiness(){
        return new WebApis.BusinessApi()
        .FindAll()
        .then((r) => {
          r = r.data.Data;
          this.Businesses = r;
          this.BusinessItems=[{"BusinessName":"请选择商户","BusinessCode":null}];
          this.Businesses.forEach(p=>{
            this.BusinessItems.push({"BusinessName":p.BusinessName,"BusinessCode":p.BusinessCode});
          });
          this.slots[0].values=this.BusinessItems;
          this.InitChildBusiness();
        })
        .catch((e) => {
          
          var error=e.RspMsg ? "获取商户数据异常！" + e.RspMsg : "获取商户数据异常！";
          
          Toast(error);
        });
    },
     InitChildBusiness()
    {
      let user = this.user;

      if(user.LoginName!="admin")
      {
          var SelectedBusiness= this.GetBusinessByUser(user);

          if(SelectedBusiness)
          {
            this.BusinessCode = SelectedBusiness.BusinessCode;
            if(SelectedBusiness.IsMain=="1")
            {
               this.BusinessCode="";
               this.BusinessName="";
               this.BusinessCodeDisabled=false;
            }
          }

          if(!this.BusinessCode)
          {
              this.GetChildBusinessByChildBusinessCode(user.LoginName);
          }
          else
          {
              this.GetChildBusinesses(this.BusinessCode);
              this.BusinessCodeDisabled=true;
          }
      }
      else
      {
        this.BusinessCode="";
        this.BusinessCodeDisabled=false;
      }
    },
     GetChildBusinesses(BusinessCode) {

      let ChildBusinessSearch = {
        BusinessCode:BusinessCode
      };

      return new WebApis.ChildBusinessApi()
        .FindByConditions(ChildBusinessSearch)
        .then((r) => {
          this.ChildBusinesses = r.data.Data;
          this.ChildBusinessItems=[{"ChildBusinessName":"请选择子商户","ChildBusinessCode":null}];
          this.ChildBusinesses.forEach(p=>{
            this.ChildBusinessItems.push({"ChildBusinessName":p.ChildBusinessName,"ChildBusinessCode":p.ChildBusinessCode});
          });
          this.childslots[0].values=this.ChildBusinessItems;
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取子商户数据异常！" + e.RspMsg
              : "获取子商户数据异常！",
            type: "error",
          });
        });
    },
    GetChildBusinessByChildBusinessCode(ChildBusinessCode)
    {
       let ChildBusinessSearch = {
        ChildBusinessCode:ChildBusinessCode
      };

      new WebApis.ChildBusinessApi()
        .GetItemByBusinessCodeAndChildBusinessCode(ChildBusinessSearch)
        .then((r) => {
          var result = r.data.Data;
          if(result)
          {
            this.BusinessCode = result.BusinessCode;
            this.BusinessName = result.BusinessName;
            this.BusinessCodeDisabled=true;
            utils.waitAll([
                      () => this.GetChildBusinesses(this.BusinessCode)
                    ]).then(()=>{
                        this.ChildBusinessCode = result.ChildBusinessCode;
                        this.ChildBusinessCodeDisabled=true;
                    });
          }
          
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取子商户数据异常！" + e.RspMsg
              : "获取子商户数据异常！",
            type: "error",
          });
        });
    },
    GetBusinessByUser(user)
    {
       var result="";
        this.Businesses.forEach(function(item){
            if(item.BusinessCode==user.LoginName)
            {
              result= item;
              return;
            }
        });
        return result;
    },
    GetMainBusiness()
    {
       var result="";
        this.Businesses.forEach(function(item){
            if(item.IsMain=="1")
            {
              result= item;
              return;
            }
        });
        return result;
    },
    SearchOrders()
    { 
      this.queryLoading= false,
      this.moreLoading=false,
      this.allLoaded=false,

      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });

      this.initSum();

      this.currentPage=1;
      this.orderdatas=[];
      this.GetOutPayment();
    },
    GetOutPayment() {
      this.popupVisible=false;
      var _this = this;
      let BusinessOrderSearch = {
        PageSize: _this.pageSize,
        PageIndex: _this.currentPage,
        Status:_this.PayStatus==0||_this.PayStatus==undefined?null:_this.PayStatus,
        OrderNo: _this.Order_Code == ""||_this.Order_Code==undefined ? null : _this.Order_Code,
        SubMerId:_this.BusinessCode==""||_this.BusinessCode==undefined?null:_this.BusinessCode,
        Extends1:_this.ChildBusinessCode==""||_this.ChildBusinessCode==undefined?null:_this.ChildBusinessCode,
        BeginDate:new Date(this.Time_Start),
        EndDate:new Date(this.Time_End),
        TotalCount: 0
      };

      return new WebApis.BusinessOutPaymentApi()
        .GetPageContentByConditions(BusinessOrderSearch)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.tableData.forEach(p=>{
            this.orderdatas.push(p);
          });
          this.total = r.BaseSearch.TotalCount;
          Indicator.close();
        })
        .catch((e) => {
          Indicator.close();
          console.log(e);
          var error=e.RspMsg ? "获取商户订单数据异常！" + e.RspMsg : "获取商户订单数据异常！";
          Toast(error);
        });
    },
    getCurrentTime() {
        //获取当前时间并打印
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth()+1<10?'0'+(new Date().getMonth()+1):new Date().getMonth()+1;
        let dd = new Date().getDate();
        let hh = new Date().getHours();
        let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
        let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
        let nowtime = yy+'-'+mm+'-'+dd+'T'+hh+':'+mf+':'+ss;
        return nowtime;
    },
    selectBusiness(){
      if(this.LoginIsMain=="1")
        this.BusinessVisible=true;
    },
    selectChildBusiness()
    {
      if(this.BusinessName=="")
      {
        Toast("请先选择商户");
        return;
      }

      this.ChildBusinessVisible=true;
      
    },
    selectPayStatus()
    {
      this.PayStatusVisible=true;
    },
    selectStartTime()
    {
      this.$refs.TimeStartPicker.open();
    },
    selectEndTime()
    {
      this.$refs.TimeEndPicker.open();
    },
    handleStartTimeConfirm(data)
    {
      this.Time_Start=moment(data).format('YYYY/MM/DD')+" 00:00:00";
    },
    handleEndTimeConfirm(data)
    {
      this.Time_End=moment(data).format('YYYY/MM/DD')+" 23:59:59";
    },
    get_Day(day) {
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds);
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      //let timevalue= new Date(tYear + "-" + tMonth + "-" + tDate);
      let timevalue = tYear + "/" + tMonth + "/" + tDate;
      return timevalue;
    },
    
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    loadMore() {
      let _this=this;
      if(_this.allLoaded){
          _this.moreLoading = true;
          return;
        }

         if(_this.queryLoading){
          return;
        }

        _this.moreLoading = !_this.queryLoading;

      _this.currentPage++;
      utils.waitAll([
                      () => _this.GetOutPayment()
                    ]).then(()=>{
                        _this.allLoaded = _this.orderdatas.length==_this.total;
                         _this.moreLoading = _this.allLoaded;
                    });
    },
    InGetSum()
    {
      let BusinessOutPaymentSearch = {
        Status:1,
        SubMerId:this.LoginBusinessCode==""?null:this.LoginBusinessCode,
        BeginDate:new Date(this.Time_Start),
        EndDate:new Date(this.Time_End)
      };

      return new WebApis.BusinessOutPaymentApi().GetPaySum(BusinessOutPaymentSearch).then((r)=>{
         r = r.data.Data;
         if(r)
         {
           this.InSumData.SumTrxAmount= r.SumTrxAmount;
           this.InSumData.SumPaySeparate=r.SumPaySeparate;
           this.InSumData.SumMainPaySeparater=r.SumMainPaySeparater;
         }
      });
    },
    ReturnGetSum()
    {
      let BusinessOutPaymentSearch = {
        Status:2,
        SubMerId:this.LoginBusinessCode==""?null:this.LoginBusinessCode,
        BeginDate:new Date(this.Time_Start),
        EndDate:new Date(this.Time_End)
      };

      return new WebApis.BusinessOutPaymentApi().GetPaySum(BusinessOutPaymentSearch).then((r)=>{
         r = r.data.Data;
         if(r)
         {
           this.ReturnSumData.SumTrxAmount= r.SumTrxAmount;
           this.ReturnSumData.SumPaySeparate=r.SumPaySeparate;
           this.ReturnSumData.SumMainPaySeparater=r.SumMainPaySeparater;
         }
      });
    },
    GetSumData()
    {
      this.SumTrxAmount = this.InSumData.SumTrxAmount-this.ReturnSumData.SumTrxAmount;
      this.SumPaySeparate = this.InSumData.SumPaySeparate-this.ReturnSumData.SumPaySeparate;
      this.SumMainPaySeparater = this.InSumData.SumMainPaySeparater-this.ReturnSumData.SumMainPaySeparater;

      this.SumTrxAmount=parseFloat(this.SumTrxAmount).toFixed(2);
      this.SumPaySeparate=parseFloat(this.SumPaySeparate).toFixed(2);
      this.SumMainPaySeparater=parseFloat(this.SumMainPaySeparater).toFixed(2);

       if(this.LoginIsMain=="1")
       {
         this.GetPaySeparate=this.SumMainPaySeparater;
       }
       else
       {
         this.GetPaySeparate=this.SumPaySeparate;
       }
    },
    InitLogin()
    {
       let user = this.user;
      if(user.LoginName!="admin")
      {
         var SelectedBusiness= this.GetBusinessByUser(user);

          if(SelectedBusiness)
          {
            if(SelectedBusiness.IsMain=="1")
            {
               this.LoginIsMain=SelectedBusiness.IsMain;
               this.LoginBusinessName=SelectedBusiness.BusinessName
               this.LoginBusinessCode="";
            }
            else
            {
              this.LoginBusinessName=SelectedBusiness.BusinessName;
              this.LoginBusinessCode=SelectedBusiness.BusinessCode;

              this.BusinessCode=SelectedBusiness.BusinessCode;
              this.BusinessName=SelectedBusiness.BusinessName;
              
            }
          }
      }
      else
      {
          var Selected_Business = this.GetMainBusiness();
          this.LoginIsMain=Selected_Business.IsMain;
          this.LoginBusinessName=Selected_Business.BusinessName
          this.LoginBusinessCode="";
      }
    }
  },
  computed: {
   
  }
};

</script>
<style  scoped>

.orderspace{
  padding:0.2rem;
  background-color: white;
  margin: 0.1rem;
  line-height: 0.2rem;
}

.order_item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.3rem;
  color: #333;
  line-height: 0.6rem;
}

.order_item_num{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.3rem;
  color: #333;
  line-height: 0.5rem;
}

.item_l{
  color: #1f1e1e;
  width: 4rem;
}

.item_l_num{
  color: #1f1e1e;
}

.item_v_num{
  font-size: 0.3rem;
}

.item_v_time{
  font-size: 0.3rem;
  width:4rem;
}

.search .mint-popup {
  height: 100%;
  width: 100%;
}

.select .mint-popup {
  height: 30%;
  width: 100%;
}

.select /deep/ .picker-slot{
  font-size:0.28rem;
}

.selecttime 
{
  width: 100%;
}

.selecttime /deep/ .picker-slot{
  font-size:0.28rem;
}

.selecttime /deep/ .mint-datetime-action{
  font-size:0.33rem;
}

.selecttime /deep/ .picker-toolbar{
  height: 60px;
}



.searchbutton .mint-button
{
  margin-top:0.5rem;
  width:80%;
  height: 0.6rem;
}

.popupItem{
  width:100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.popupName
{
  width:30%;
  font-size: 0.3rem;
  border-top: 1px;
  border-bottom: 1px;
  border-left: 0px;
  border-right: 0px;
  border-style:dashed;
  height: 0.7rem;
}

.popupValue
{
  width: 70%;
  font-size: 0.3rem;
  height: 0.7rem;
  border-top: 1px;
  border-bottom: 1px;
  border-left: 0px;
  border-right: 0px;
  border-style:dashed;
  color:grey;
  text-align: left;
  vertical-align:middle;
}

.popupValue .mint-field
{
    margin-top: 0rem;
    margin-bottom: 0rem;
    margin-left: 0rem;
    margin-right: 0rem;
    border-style:dashed;
    height: 0.5rem;
    border-top: 1px;
    border-bottom: 1px;
    border-left: 0px;
    border-right: 0px;
}

.popupValue  /deep/ .mint-field input
{
    font-size: 0.3rem;
    color:grey;
}


.more_loading
{
  font-size: 0.3rem;
  text-align: center;
}

.more_loading /deep/ .mint-spinner-snake
{
  margin-left: auto;
  margin-right: auto;
}

.orderSum{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.3rem;
  color: #333;
  line-height: 0.6rem;
}

.orderSum .orderTitle{
  font-size: 0.3rem;
  width:30%;
}

.orderSum .orderValue{
  font-size: 0.3rem;
  width:70%;
}



</style>